<div class="book-a-meeting contact-option" (click)="bookMeeting()">
  <mat-icon class="icon">today</mat-icon>
  {{ 'COMMON.BOOK_A_MEETING' | translate }}
</div>
